import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { BasicBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { borderColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderColor";
import { borderStyle } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderStyle";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { sizing } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/sizing";
import {
  BorderProp,
  DesignProp,
  MarginsProp,
  PaddingsProp,
  SizingProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { borderWidth } from "../../../ModifiedStyleAttributes/borderWidth";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Line",
  version: 1,
  nameI18n: "builder_ui.block_type.line",
  category: [BasicBlock],
  props: {
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        sizing: {
          ...sizing,
          defaultValue: defaultStyles.sizing,
          category: [DesignProp, SizingProp],
        },
        borderStyle: {
          ...borderStyle,
          defaultValue: defaultStyles.borderStyle,
          category: [DesignProp, BorderProp],
        },
        borderColor: {
          ...borderColor,
          type: "color-without-alpha",
          defaultValue: defaultStyles.borderColor,
          category: [DesignProp, BorderProp],
        },
        borderTopWidth: {
          ...borderWidth,
          defaultValue: defaultStyles.borderTopWidth,
          category: [DesignProp, BorderProp],
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        },
      },
    },
  },
};
